import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Trebuchet",
  "description": "",
  "published": "2006-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/trebuchet/swizec/373"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/trebuchet.jpg"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/trebuchet_thumb.jpg",
          "alt": "Trebuchet",
          "title": "Trebuchet"
        }}></img></a></p>
    <p>{`No, pa smo pri prvem dnevu dnevnih blogov in le upam lahko, da z le-temi ne bo problemov, ker ponavadi ni veliko zanimivega za povedat, ampak seveda se lahko vsako stvari naredi zanimivo z dobrim pisanjem, kar pa je v bistvu celoten namen tega podviga. Kaj ne? No, slika zgoraj je povezava na skupek fotografij lego trebucheta, ki sem ga sestavil v zadnjih nekaj dneh in danes zapravil veliko casa s streljanjem.`}</p>
    <p>{`Kot lahko vidite, ni ravno najvecji trebuchet v obstoju, vendar je vseeno kar zajeten in je gotovo najvisja lego kreacija kar sem jih kdaj ustvaril. Protiutez je trenutno napolnjena s kovanci, kar omogoca domet priblizno 5 metrov in le upam lahko, da ribiski svinec ni predrag in bo lahko nadomestil trenutno polnilo.`}</p>
    <p>{`Vceraj sem se slucajno spotaknil ob `}<a parentName="p" {...{
        "href": "http://jenwang.net/art/comics/touchfood/"
      }}>{`zelo prijeten mali strip`}</a>{`, ki ga mocno priporocam v branje. Najverjetneje bi vas zanimalo tudi `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=NaNoWriMo"
      }}>{`tole`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      